import React from 'react';
import { textos } from './textos';

/**
 * A opção JÁ ESCOLHIDA de um select é sempre opção, mesmo fora da lista carregada (08/10/2026).
 *
 * Quando a lista de opções não carregava (ou não trazia aquele item), o `<select value={id}>` ficava sem a opção do
 * valor e o navegador mostrava a primeira: "Sem responsável" numa demanda que TEM responsável, "padrão"/"— Selecione —"
 * numa linha de DDR que TEM operadora. Nada se gravava errado (o id fica no estado), mas o campo de decisão afirmava
 * o falso. Com esta opção, o select mostra o valor real; com a lista sem carregar, diz isso no próprio rótulo.
 */
export function opcaoAtualForaDaLista(
  lista: Array<{ id: number | string }> | null | undefined,
  id: number | string | null | undefined,
  rotulo: string,
  listaNaoCarregou: boolean,
): React.ReactElement | null {
  if (id === null || id === undefined || id === '') return null;
  // Comparado como TEXTO (08/10/2026): o id da instância EC2 é 'i-0abc…', e `Number(id)` virava NaN, nunca casava, e a
  // opção atual saía duplicada. Para id numérico é o mesmo resultado ('7' e 7 casam).
  if ((lista || []).some((x) => String(x.id) === String(id))) return null;
  return <option value={id}>{rotulo}{listaNaoCarregou ? textos.listaNaoCarregouNoRotulo : ''}</option>;
}

/**
 * A SAÍDA NOMEADA da catraca do select sem a opção atual (scripts/check-select-sem-atual.js, 08/10/2026), para o
 * select cuja lista não falha ao carregar mas a régua conta (lista derivada no próprio componente, com nome
 * minúsculo). Vai no corpo do select e não desenha nada: `{opcaoAtualDispensada('as UFs saem de um mapa fixo')}`.
 * O motivo é obrigatório; uma busca pelo nome lista todas as dispensas.
 */
export function opcaoAtualDispensada(motivo: string): null {
  if (motivo.trim().length < 10) throw new Error('opcaoAtualDispensada: diga por que este select não precisa da opção atual');
  return null;
}
